// extracted by mini-css-extract-plugin
export default {"root":"Xtu1tlA1FGjSM81lSntu","placeHolderShimmer":"OWL9uQScdzE16a81d2bc"};